// src/components/Sidebar.jsx
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Users, Settings, LogOut, Globe2 } from 'lucide-react';

export default function Sidebar({ user, onLogout }) {
  const [sites, setSites] = useState([]);
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    async function loadSites() {
      try {
        const res = await fetch('/api/sites');
        if (!res.ok) return;
        const data = await res.json();
        if (!cancelled) setSites(data.sites || []);
      } catch (e) {
        // Keep sidebar usable even if site list cannot load.
      }
    }
    loadSites();
    window.addEventListener('sm-sites-updated', loadSites);
    return () => {
      cancelled = true;
      window.removeEventListener('sm-sites-updated', loadSites);
    };
  }, []);

  return (
    <nav className="sidebar">
      <div className="sidebar-main">
        <Link to="/" className={`nav-item ${location.pathname === '/' ? 'active' : ''}`}>
          <Home size={20} /> Dashboard
        </Link>
        <Link to="/profile" className={`nav-item ${location.pathname === '/profile' ? 'active' : ''}`}>
          <Settings size={20} /> Profile
        </Link>
        {user?.role === 'superadmin' && (
          <Link to="/team" className={`nav-item ${location.pathname === '/team' ? 'active' : ''}`}>
            <Users size={20} /> Team Settings
          </Link>
        )}

        <div className="sidebar-sites">
          <div className="sidebar-section-title"><Globe2 size={15} /> List Sites</div>
          {sites.length === 0 ? <div className="sidebar-empty">No sites added</div> : sites.map(site => {
            const active = Number(site.bridge_enabled) === 1 || Number(site.connector_enabled) === 1;
            const current = location.pathname === `/sites/${site.id}`;
            return (
              <Link key={site.id} to={`/sites/${site.id}`} className={`sidebar-site-link ${current ? 'active' : ''}`} title={`${site.name} — ${active ? 'Connector active' : 'Connector inactive'}`}>
                <span className={`site-dot ${active ? 'green' : 'red'}`} />
                <span className="site-name">{site.name}</span>
              </Link>
            );
          })}
        </div>
      </div>

      <button onClick={onLogout} className="nav-item logout">
        <LogOut size={20} /> Logout
      </button>
    </nav>
  );
}
